module.exports = __webpack_public_path__ + "materialdesignicons-webfont.eot?f81583fc4d8aa5aa2820976561ea8aec";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.eot?v=4.7.95
// module id = 1213
// module chunks = 0